module.exports = __webpack_public_path__ + "static/media/preto.a0a2c9f9.jpg";